export default __webpack_public_path__ + "static/media/wow xl .ff390ee3.png";